module.exports = __webpack_public_path__ + "static/media/surgeryInstructions.8281aff2.mp3";